export const getArrayOfOptions = (countOfOptions: number) => {
  return Array.from({ length: countOfOptions }, (_, i) => ({
    value: i + 1,
    label: String(i + 1),
  }));
};
